export default function homepage_slider() {
    (function($){

        var initializeBlock = function( $block ) {
            $block.find('.homepage_slides').slick({
                dots: true,
                infinite: true,
                speed: 300,
                //cssEase: 'linear',
                centerMode: false,
                arrows: true,
                prevArrow: '<div class="homepage_slider_arrow_prev"><span class="fa fa-angle-left"></span><span class="sr-only">Prev</span></div>',
                nextArrow: '<div class="homepage_slider_arrow_next"><span class="fa fa-angle-right"></span><span class="sr-only">Next</span></div>'
            });   
        }
    
        // Initialize each block on page load (front end).
        $(document).ready(function(){
            $('.homepage_slider').each(function(){
                initializeBlock( $(this) );
            });
        });
    
        // Initialize dynamic block preview (editor).
        if( window.acf ) {
            window.acf.addAction( 'render_block_preview/type=homepage_slider', initializeBlock );
        }

    })(jQuery);
}